<template>
    <div class="version flex-col page text-df text-black">
        <div class="padding-sm traffic" v-if="sata">
            <div class="padding-sm text-gray">
                <div>时间周期：{{sata.startDate}}-{{sata.endDate}}</div>
                <div>数据更新时间：{{sata.updateTime}}</div>
            </div>
            <div class="traddic-box">
                <bottomModal>
                    <div class="traddic-title flex align-center justify-start text-500" v-if="userinfo && userinfo.resetRightsDay">
                        <div class="text-lg">本月剩余用量</div>
                        <div class="text-gray">（下次用量重置时间：{{userinfo.resetRightsDay[2]}}月{{userinfo.resetRightsDay[3]}}日）</div>
                        <div class="cuIcon-question text-gray"></div>
                    </div>
                    <div slot="part">
                        <div class="padding-sm">
                            <div class="text-40 text-500">关于余量重置</div>
                            <div class="margin-top-xxl text-lg">月度余量会按套餐购买日期，以非自然月（31天）进行重置，上月套餐剩余容量不可累计使用，次月将清零重置。</div>
                            <div class="notice-new margin-top-xxl">示例说明</div>
                            <div class="radius padding bg-gray margin-top-lg">例如：2023年11月10日购买，则2023年12月11日重置。</div>
                        </div>
                    </div>
                </bottomModal>

                <div class="padding-lr">
                    <el-progress color="#3DC4A7" :show-text="false" :text-inside="true"
                                 :stroke-width="6" :percentage="((sata.userCdnTrafficData.consumeTraffic/1+sata.userCdnTrafficData.deletedTraffic/1+sata.userCdnTrafficData.otherTraffic/1)/sata.userCdnTrafficData.totalTraffic)*100"></el-progress>
                    <bottomModal cla="rightXClose full auto-height bg-f5f5f5">
                        <div class="flex align-center justify-between margin-top-sm">
                            已使用 {{sizeG(sata.userCdnTrafficData.consumeTraffic/1+sata.userCdnTrafficData.deletedTraffic/1+sata.userCdnTrafficData.otherTraffic/1,'G')}} / 总量 {{sizeG(sata.userCdnTrafficData.totalTraffic,'G')}}
                            <div class="traddic-info" v-if="surplus">余量详情</div>
                        </div>
                        <div slot="part">
                            <div class="padding-sm margin-top-lg">
                                <div class="text-lg text-500 text-center">余量明细</div>
                                <div class="margin-top-lg text-lg bg-white radius padding-lr-sm padding-tb-lg">
                                    <div class="flex align-center justify-between">
                                        <div>月套餐余量（G)</div>
                                        <div class="text-right">{{sizeG(surplus.packageSurplus)}}</div>
                                    </div>
                                    <template v-for="si in surplus.purchaseCdnTrafficList">
                                        <div class="flex align-center justify-between margin-top-lg">
                                            <div style="max-width: 75%;" class="text-enter">{{si.trafficName}}（G)</div>
                                            <div class="text-right">{{sizeG(si.traffic)}}</div>
                                        </div>
                                    </template>
                                </div>

                            </div>
                            <div class="margin-top-xxl text-df bg-white radius padding-tb-lg padding-lr-sm" style="margin-top: 84px;">
                                <div class="padding-lr-sm">活动云流量消耗较大，可通过升级版本或者单独增加流量</div>
                            <div class="flex align-center justify-between margin-top-lg">
                                <div style="width: 170px;height: 45px;border: 1px solid #E3A667;border-radius: 23px;line-height: 45px;"
                                     @click="gotoVip"
                                     class="text-yellow text-center text-xl padding-lr-xl">升级版本</div>

                                <div style="width: 170px;height: 45px;background-image: linear-gradient(1deg, #E09D59 0%, #F1DAB9 100%);border-radius: 23px;line-height: 45px;"
                                     @click="gotoBuyTraffic"
                                     class="text-white text-center text-xl padding-lr-xl">增加流量</div>
                            </div>
                            </div>
                        </div>
                    </bottomModal>
                </div>
                <div style="background-color: #F4F7FF;" class="margin-lr-xs padding radius margin-top text-gray flex align-center justify-between">
                    <div>
                        <div class="">已用(G)</div>
                        <div class="margin-top-lg text-500 text-lg text-black">{{sizeG(sata.userCdnTrafficData.consumeTraffic/1+sata.userCdnTrafficData.deletedTraffic/1+sata.userCdnTrafficData.otherTraffic/1)}}</div>
                    </div>
                    <div>
                        <div>日均使用(G)</div>
                        <div class="margin-top-lg text-500 text-lg text-black">{{sizeG((sata.userCdnTrafficData.consumeTraffic/1+sata.userCdnTrafficData.deletedTraffic/1+sata.userCdnTrafficData.otherTraffic/1)/31)}}</div>
                    </div>
                    <div>
                        <div>剩余(G)</div>
                        <div class="margin-top-lg text-500 text-lg"
                             :class="(sata.userCdnTrafficData.totalTraffic/1-sata.userCdnTrafficData.consumeTraffic/1-sata.userCdnTrafficData.deletedTraffic/1-sata.userCdnTrafficData.otherTraffic/1)<0?'text-red':'text-black'">{{sizeG(sata.userCdnTrafficData.totalTraffic/1-sata.userCdnTrafficData.consumeTraffic/1-sata.userCdnTrafficData.deletedTraffic/1-sata.userCdnTrafficData.otherTraffic/1)}}</div>
                    </div>
                </div>
                <div class="flex align-center justify-between notice-bar" v-if="(sata.userCdnTrafficData.totalTraffic/1-sata.userCdnTrafficData.consumeTraffic/1-sata.userCdnTrafficData.deletedTraffic/1-sata.userCdnTrafficData.otherTraffic/1)<0">
                    <div class="flex align-center justify-start text-lg">
                        <div class="cuIcon-noticefill margin-right-xs"></div>
                        <div class="text-df">剩余云流量不足，建议增加流量</div>
                    </div>
                    <div class="button-buy" @click="serviceDialogShow">增加</div>
                </div>
            </div>
            <div class="traddic-box margin-top-sm">
                <bottomModal>
                    <div class="traddic-title flex align-center justify-start text-500">
                        <div class="text-lg">其他云流量</div>
                        <div class="cuIcon-question text-gray margin-left-xs"></div>
                    </div>
                    <div slot="part">
                        <div class="padding-sm">
                            <div class="text-40 text-500">关于其他云流量</div>
                            <div class="margin-top-xxl text-lg">
                                其他：包含个人主页封面等
                                <br><br>
                                已删除活动：当月已删除的所有活动消耗
                            </div>
                        </div>
                    </div>
                </bottomModal>
                <div style="background-color: #F4F7FF;" class="margin-lr-xs padding radius text-gray flex align-center justify-start">
                    <div>
                        <div class="">其他已用(G)</div>
                        <div class="margin-top-lg text-500 text-lg text-black">{{sizeG(sata.userCdnTrafficData.otherTraffic)}}</div>
                    </div>
                    <div style="margin-left: 60px;">
                        <div>删除活动已用(G)</div>
                        <div class="margin-top-lg text-500 text-lg text-black">{{sizeG(sata.userCdnTrafficData.deletedTraffic)}}</div>
                    </div>
                </div>
            </div>
            <div class="traddic-box margin-top-sm" v-if="activitys.length>0">
                <div class="traddic-title flex align-center justify-start text-500">
                    <div class="text-lg">活动云流量Top10</div>
                </div>
                <div style="background-color: #F4F7FF;" class="margin-lr-xs padding radius ">
                    <div class="th text-gray flex align-center justify-between">
                        <div class="table-no">序号</div>
                        <div class="table-name">活动名称</div>
                        <div class="table-views">浏览次数</div>
                        <div class="table-traddic text-cut">流量消耗（G)</div>
                    </div>
                    <template v-for="(item,idx) in activitys">
                        <div class="td flex align-center justify-between margin-top-lg">
                            <div class="table-no">{{idx+1}}</div>
                            <div class="table-name text-cut">{{item.activityName}}</div>
                            <div class="table-views">{{item.views}}</div>
                            <div class="table-traddic">{{sizeG(item.traffic)}}</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <serviceDialog ref="serviceDialog"></serviceDialog>
    </div>
</template>

<script>
  import App from '../util/comfun'
  import bottomModal from '../components/common/bottom-modal.vue'
  import serviceDialog from '../components/service-dialog.vue'
  export default {
    components: {
      bottomModal,
      serviceDialog,
    },
    props: {},
    data() {
      return {
        hasManager:false,
        userinfo:{},
        VERSIONS:{},
        hasUsePayBut:false,
        hasInBusiness:0,
        sata:null,
        activitys:[],
        surplus:null,
      };
    },

    methods: {
      sizeG:App.sizeG,
      isManager(){
        App.demand('user/isManager/current','GET').then(res=>{
          this.hasManager=res.data.isManager===true
          //this.getUserInfo()
          this.hasUsePayBut=this.usePayBut()
        })
      },
      async getUserInfo(){
        let userinfo=(await App.demand('/user/info','GET',{
          userId:this.options.uid||this.options.userId,
        })).data
        let resetRightsDay=userinfo.resetRightsDay.match(/([\d]{4})([\d]{2})([\d]{2})/)
        this.userinfo={
          userName:userinfo.userName,
          avatar:userinfo.avatar,
          id:userinfo.id,
          vipType:userinfo.vipType,
          endTime:userinfo.endTime,
          resetRightsDay:resetRightsDay,
        }
        App.demand('/user/traffic/info','GET',{
          userId:this.options.uid||this.options.userId
        }).then(res=>{
          let sata=res.data
          sata.updateTime=App.unixtoTime(sata.updateTime,'YYYY/MM/DD HH:II')
          sata.startDate=sata.startDate.replace(/([\d]{4})([\d]{2})([\d]{2})/,function($0,y,m,d){
            return `${y}.${m}.${d}`
          })
          sata.endDate=sata.endDate.replace(/([\d]{4})([\d]{2})([\d]{2})/,function($0,y,m,d){
            return `${y}.${m}.${d}`
          })
          this.sata=sata
        })
        App.demand('/user/traffic/cdn/surplus','GET',{
          userId:this.options.uid||this.options.userId
        }).then(res=>{
          this.surplus=res.data
        })
        App.demand('/activity/loadActivityTrafficList','GET',{
          userId:this.options.uid||this.options.userId
        }).then(res=>{
          this.activitys=res.data||[]
          if(this.loading) this.loading.close()
        })
      },
      async getVersion(){
        let vds=(await App.demand('/activity/version/loadConfigList','GET')).data;
        let vers={};
        vds.forEach(ver=>{
          vers[ver.versionType]=ver
        });
        this.VERSIONS=vers
        ////////
      },
      unixtoTime:App.unixtoTime,
      serviceDialogShow(){
        this.$refs.serviceDialog.show()
      },
      usePayBut(){
        let hasiPhone=window.navigator.userAgent.toLocaleLowerCase().indexOf('iphone')>-1
        if(this.options.from=='wxlite' && hasiPhone) {
          //return this.hasManager
          return false
        }
        return true
      },
      gotoVip(){
        let hasDebug=location.href.indexOf('--DEBUG--')>-1
        let path=App.http_build_query({
          'version':encodeURIComponent(JSON.stringify(this.options))
        },'/',true)
        path=path.replace('/#/','/')
        console.error(path)
        this.$router.push(path)
      },
      gotoBuyTraffic(){
        let hasDebug=location.href.indexOf('--DEBUG--')>-1
        let path=App.http_build_query({
          'buy-traffic':encodeURIComponent(JSON.stringify(this.options))
        },'/',true)
        path=path.replace('/#/','/')
        console.error(path)
        this.$router.push(path)
      },
    },
    /**
     * from,token,userId
     */
    mounted(){
      this.loading = this.$loading({
        lock: true,
        text: '正在加载',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let hasLogined=false
      if(this.$route.params.options){
        try{
          this.options=JSON.parse(decodeURIComponent(this.$route.params.options))
          hasLogined=true
          this.hasInBusiness=this.options.hasInBusiness
          if(this.hasInBusiness==1){

          }
        }catch (e){}
      }
      console.info('hasLogined',hasLogined,this.options)
      if(!hasLogined || !this.options || typeof this.options!='object'){return App.wxLogin()}
      this.getVersion()
      console.log('options',this.options)
      wxlite.setStorageSync('token',this.options.token)
      //this.isManager()
      this.getUserInfo()
      document.querySelector('body').setAttribute('style', 'background-color:#EBEBEB;')
    },
  };
</script>

<style scoped lang="css">
    @import "../../static/icon.css";
    .version.page {
        background-color: #EBEBEB;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0 auto;
        position: relative;
    }
    .version::before{
        width: 100%;
        height: 213px;
        background: #C5EDE4;
        content: "";
        top:0;
        left:0;
        position: absolute;
    }
    .traffic{
        position: relative;
        z-index: 1;
        width: 375px;
        margin: 0 auto;
    }
    .traddic-box{
        width: 355px;
        background: #FFFFFF;
        box-shadow: 0 0 3px 0 #D7FCF4;
        border-radius: 10px;
        padding-bottom: 15px;
    }
    .traddic-title{
        width: 100%;
        height: 55px;
        background-image: linear-gradient(180deg, #EFFFFB 0%, #FFFFFF 100%);
        border-radius: 10px 10px 0 0;
        padding-left: 15px;
    }
    .traddic-info{
        width: 80px;
        height: 20px;
        border: 1px solid #3DC4A7;
        border-radius: 13px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        color: var(--green);
    }
    .table-no{
        width: 44px;
        min-width: 44px;
    }
    .table-name{
        width: 126px;
        min-width: 126px;
    }
    .table-views{
        width: 77px;
        min-width: 77px;
    }
    .table-traddic{
        width: 77px;
        min-width: 77px;
    }
    .notice-bar{
        margin: 10px 5px 0;
        height: 30px;
        background: #FFEFEF;
        border-radius: 15px;
        padding: 0 10px;
        box-sizing: border-box;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #E0605A;
        letter-spacing: 0;
    }
    .button-buy{
        width: 80px;
        height: 25px;
        background-image: linear-gradient(1deg, #E09D59 0%, #F1DAB9 100%);
        border-radius: 13px;

        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
        line-height: 25px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/traffic.vue